import { render } from "./Editor.vue?vue&type=template&id=32b3df17&scoped=true"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"

import "./Editor.vue?vue&type=style&index=0&id=32b3df17&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32b3df17"

export default script